import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Row, Col } from 'antd';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';

const { RangePicker } = DatePicker;

class FormFilterDateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formFilterDatePicker: {
        input: '',
      },
    };
  }

  onChange = (date, dateString) => {
    const formFilterDatePicker = {
      input: dateString,
    };
    this.setState({ formFilterDatePicker });
  };

  onCancel = () => {
    this.props.cancelFunction(
      this.props.type,
      this.props.flagType,
      this.props.callbackCancel,
    );
  };

  _onValidate = err => {
    if (!err) {
      this.props.onSubmit(
        this.props.type,
        this.state.formFilterDatePicker,
        this.props.flagType,
      );
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderForm = () => {
    const {
      form: { getFieldDecorator },
      showTime,
      ranges,
    } = this.props;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col>
            <Form.Item required={false} colon={false}>
              {getFieldDecorator('rangepicker', {
                rules: [
                  {
                    required: true,
                    message: 'date range required',
                  },
                ],
              })(
                <RangePicker
                  onChange={this.onChange}
                  className="date-picker-style"
                  dropdownClassName="filter-date-range-picker"
                  showTime={showTime}
                  ranges={
                    ranges || {
                      Today: [moment().startOf('day'), moment().endOf('day')],
                      'Last 7 Day': [moment().subtract(7, 'days'), moment()],
                      'Last 30 Day': [moment().subtract(30, 'days'), moment()],
                      'This Month': [
                        moment().startOf('month'),
                        moment().endOf('month'),
                      ],
                    }
                  }
                />,
              )}
            </Form.Item>
          </Col>
          <div className="row-submit">
            <Button className="btn cancel-btn" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="btn">
              Submit
            </Button>
          </div>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormFilterDateRangePicker.propTypes = {
  form: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  flagType: PropTypes.string.isRequired,
  callbackCancel: PropTypes.func,
  showTime: PropTypes.bool,
  ranges: PropTypes.object,
};

export default FormFilterDateRangePicker;
